import { FC, useState } from "react";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { Text, HStack, Icon, Spinner, Center } from "@chakra-ui/react";

import { PdfIcon } from "../../../icons";
import { IDocument } from "../../../../api/documents/types";
import { axiosInstance } from "../../../../api/axiosConfig";
import { downloadFile } from "../../../../utils/downloadFiles";

interface Props {
  document: IDocument;
}

export const DocumentsPageDocumentItem: FC<Props> = ({ document }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const onClick = async () => {
    if (!document.link) {
      return;
    }

    setIsLoading(true);
    setIsError(false);

    try {
      const response = await axiosInstance.get(document.link, {
        responseType: "blob",
      });

      downloadFile({
        response,
        defaultFilename: document.name ? `${document.name}.pdf` : "документ.pdf",
      });
    } catch (err: unknown) {
      console.error(err);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  if (!document.name || !document.link) {
    return null;
  }

  return (
    <HStack
      w="100%"
      mb="32px"
      justifyContent="space-between"
      position="relative"
      onClick={onClick}
      cursor={isLoading ? "default" : "pointer"}
      pointerEvents={isLoading ? "none" : "auto"}
    >
      <HStack alignItems="flex-start" spacing={0}>
        <Icon as={PdfIcon} boxSize="24px" mr="8px" />
        <Text variant="brand">{document.name}</Text>
      </HStack>

      {isLoading
        ? (
          <Center>
            <Spinner variant="purple" boxSize="20px" />
          </Center>
          )
        : <Icon boxSize="16px" as={ChevronRightIcon} color="brand.500" strokeWidth="2px" mt="2px" mr="1px" />}

      {isError
      && (
        <Text
          color="red.500"
          fontSize="12px"
          position="absolute"
          bottom="-14px"
          left="32px"
        >
          Не удалось загрузить документ
        </Text>
      )}
    </HStack>
  );
};
